import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import Home from '../pages/Home/index';
import Familia from '../pages/Familia/index';
import Login from '../pages/Login/index';
import Cadastro from '../pages/DadosCadastrais/Cadastro/index';
import Consulta from '../pages/DadosCadastrais/Consulta/index';
import Historico from '../pages/Historico';
import Feriado from '../pages/Feriado';
import Modulo from '../pages/Modulo'
import Permissao from '../pages/Permissao'
import Error from '../pages/Error';
import Relatorios from '../pages/Relatorios';
import Servico from '../pages/Servico';
import Orgao from '../pages/Orgao';
import VinculoOrgaoServico from '../pages/VinculoOrgaoServico';
import Escolaridade from '../pages/Escolaridade';
import DadosSuporte from '../pages/DadosSuporte';
import Bloqueio from '../pages/Bloqueio';

const Routes = (props) => {
  
    const isLoggedIn = () => !!sessionStorage.getItem('usuarioLogado');
    const SecuredRoute = ({ component: Component, ...rest }) => (
        <Route
            {...rest}
            render={props =>
                  isLoggedIn() === true ? (
                <Component {...props} />
                  ) : (
                    <Redirect
                    to={{
                      pathname: "/login",
                      state: { message: "É necessario realizar o Login!" }
                    }}
                  />
                  )
            }
        />
    );

    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/" component={Login}></Route>
                <Route path="/login" component={Login}></Route>
                <Route path="/error" component={Error}></Route>
                <SecuredRoute path="/home" component={Home}></SecuredRoute>
                <SecuredRoute path="/familia/:dadosCadastraisID" component={Familia}></SecuredRoute>
                <SecuredRoute path="/historico" component={Historico}></SecuredRoute>
                <SecuredRoute path="/feriado" component={Feriado}></SecuredRoute>                
                <SecuredRoute path="/orgao" component={Orgao}></SecuredRoute>                
                <SecuredRoute path="/dados-cadastrais/consulta" component={Consulta}></SecuredRoute>
                <SecuredRoute path="/dados-cadastrais/cadastro/:id/agendamento/:agendamentoID/tabela/:tab" component={Cadastro}></SecuredRoute>
                <SecuredRoute path="/dados-cadastrais/cadastro/:id/tabela/:tab" component={Cadastro}></SecuredRoute>
                <SecuredRoute path="/modulo" component={Modulo}></SecuredRoute>
                <SecuredRoute path="/permissao" component={Permissao}></SecuredRoute>
                <SecuredRoute path="/relatorios" component={Relatorios}></SecuredRoute>
                <SecuredRoute path="/servico" component={Servico}></SecuredRoute>
                <SecuredRoute path="/vinculo-orgao-servico" component={VinculoOrgaoServico}></SecuredRoute>
                <SecuredRoute path="/escolaridade" component={Escolaridade}></SecuredRoute>
                <SecuredRoute path="/dados-suporte" component={DadosSuporte}></SecuredRoute>
                <SecuredRoute path="/bloqueio" component={Bloqueio}></SecuredRoute>
            </Switch>
        </BrowserRouter>
    );
};

export default Routes;